module.exports = __webpack_public_path__ + "img/uspRosette-old.79858e2e.svg";